import { createSvgIcon } from "@mui/material";

export const Instagram = createSvgIcon(
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_33_298)">
      <path d="M8.00356 4.95708C5.73213 4.95708 3.89999 6.76059 3.89999 8.99653C3.89999 11.2325 5.73213 13.036 8.00356 13.036C10.275 13.036 12.1071 11.2325 12.1071 8.99653C12.1071 6.76059 10.275 4.95708 8.00356 4.95708ZM8.00356 11.6227C6.5357 11.6227 5.3357 10.445 5.3357 8.99653C5.3357 7.54809 6.53213 6.37036 8.00356 6.37036C9.47499 6.37036 10.6714 7.54809 10.6714 8.99653C10.6714 10.445 9.47142 11.6227 8.00356 11.6227ZM13.2321 4.79184C13.2321 5.31567 12.8036 5.73403 12.275 5.73403C11.7428 5.73403 11.3178 5.31216 11.3178 4.79184C11.3178 4.27153 11.7464 3.84966 12.275 3.84966C12.8036 3.84966 13.2321 4.27153 13.2321 4.79184ZM15.95 5.74809C15.8893 4.48598 15.5964 3.36802 14.6571 2.44692C13.7214 1.52583 12.5857 1.23755 11.3036 1.17427C9.98213 1.10044 6.02142 1.10044 4.69999 1.17427C3.42142 1.23403 2.28571 1.52231 1.34642 2.44341C0.407136 3.3645 0.11785 4.48247 0.0535644 5.74458C-0.0214355 7.04536 -0.0214355 10.9442 0.0535644 12.245C0.114279 13.5071 0.407136 14.625 1.34642 15.5461C2.28571 16.4672 3.41785 16.7555 4.69999 16.8188C6.02142 16.8926 9.98213 16.8926 11.3036 16.8188C12.5857 16.759 13.7214 16.4707 14.6571 15.5461C15.5928 14.625 15.8857 13.5071 15.95 12.245C16.025 10.9442 16.025 7.04887 15.95 5.74809ZM14.2428 13.6407C13.9643 14.3297 13.425 14.8606 12.7214 15.1383C11.6678 15.5497 9.16784 15.4547 8.00356 15.4547C6.83927 15.4547 4.3357 15.5461 3.2857 15.1383C2.58571 14.8641 2.04642 14.3332 1.76428 13.6407C1.34642 12.6036 1.44285 10.1426 1.44285 8.99653C1.44285 7.85044 1.34999 5.38598 1.76428 4.35239C2.04285 3.66333 2.58213 3.13247 3.2857 2.85474C4.33928 2.44341 6.83927 2.53833 8.00356 2.53833C9.16784 2.53833 11.6714 2.44692 12.7214 2.85474C13.4214 3.12895 13.9607 3.65981 14.2428 4.35239C14.6607 5.3895 14.5643 7.85044 14.5643 8.99653C14.5643 10.1426 14.6607 12.6071 14.2428 13.6407Z" />
    </g>
    <defs>
      <clipPath id="clip0_33_298">
        <rect width="16" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Instagram"
);

export const Linkedin = createSvgIcon(
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_33_302)">
      <path
        d="M3.63269 15V4.87953H0.202386V15H3.63269ZM1.91798 3.49692C3.11419 3.49692 3.85877 2.71978 3.85877 1.74862C3.83648 0.755565 3.11423 0 1.94068 0C0.767312 0 0 0.75558 0 1.74862C0 2.71983 0.744398 3.49692 1.89559 3.49692H1.91787H1.91798ZM5.53135 15H8.96165V9.34824C8.96165 9.04576 8.98394 8.7436 9.07452 8.52738C9.32251 7.92304 9.88693 7.29712 10.8345 7.29712C12.0758 7.29712 12.5724 8.2252 12.5724 9.5857V14.9999H16.0025V9.19695C16.0025 6.08834 14.3101 4.64193 12.0532 4.64193C10.2027 4.64193 9.39021 5.65626 8.93883 6.34712H8.96173V4.87932H5.53143C5.57644 5.82897 5.53143 14.9998 5.53143 14.9998L5.53135 15Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_33_302">
        <rect width="16" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>,

  "Linkedin"
);

export const Telegram = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
  >
    <defs>
      <linearGradient id="logosTelegram0" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stop-color="#2aabee" />
        <stop offset="100%" stop-color="#229ed9" />
      </linearGradient>
    </defs>
    <path
      fill="url(#logosTelegram0)"
      d="M128 0C94.06 0 61.48 13.494 37.5 37.49A128.038 128.038 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51c0-33.934-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0"
    />
    <path
      fill="#fff"
      d="M57.94 126.648c37.32-16.256 62.2-26.974 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441c1.06-.017 3.42.245 4.96 1.49c1.28 1.05 1.64 2.47 1.82 3.467c.16.996.38 3.266.2 5.038c-1.92 20.24-10.26 69.356-14.5 92.026c-1.78 9.592-5.32 12.808-8.74 13.122c-7.44.684-13.08-4.912-20.28-9.63c-11.26-7.386-17.62-11.982-28.56-19.188c-12.64-8.328-4.44-12.906 2.76-20.386c1.88-1.958 34.64-31.748 35.26-34.45c.08-.338.16-1.598-.6-2.262c-.74-.666-1.84-.438-2.64-.258c-1.14.256-19.12 12.152-54 35.686c-5.1 3.508-9.72 5.218-13.88 5.128c-4.56-.098-13.36-2.584-19.9-4.708c-8-2.606-14.38-3.984-13.82-8.41c.28-2.304 3.46-4.662 9.52-7.072"
    />
  </svg>,

  "Telegram"
);

export const Twitter = createSvgIcon(
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_33_306)">
      <path
        d="M17.9998 1.7049C17.3257 1.98937 16.6108 2.1761 15.8787 2.25887C16.6412 1.82346 17.2267 1.13398 17.5024 0.312468C16.7776 0.722276 15.9845 1.01101 15.1574 1.1662C14.4838 0.482477 13.5241 0.0551758 12.4619 0.0551758C10.4224 0.0551758 8.76885 1.63041 8.76885 3.57326C8.76885 3.84904 8.80155 4.11752 8.86447 4.37508C5.79533 4.22831 3.07424 2.82771 1.25279 0.699175C0.934982 1.21878 0.752873 1.82319 0.752873 2.46786C0.752873 3.68848 1.40488 4.76527 2.39572 5.39621C1.80928 5.37871 1.23574 5.22781 0.72299 4.95611C0.722779 4.97085 0.722779 4.98559 0.722779 5.00039C0.722779 6.70497 1.99572 8.12694 3.68504 8.45015C3.14124 8.59105 2.57082 8.61167 2.01737 8.51044C2.48727 9.90816 3.85112 10.9253 5.46705 10.9537C4.20318 11.8973 2.61081 12.4598 0.880701 12.4598C0.582576 12.4598 0.28867 12.4431 -0.000244141 12.4106C1.63403 13.4088 3.57515 13.9913 5.66062 13.9913C12.4533 13.9913 16.1677 8.63034 16.1677 3.98127C16.1677 3.82868 16.1642 3.67695 16.157 3.5261C16.88 3.02819 17.504 2.41147 17.9998 1.7049Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_33_306">
        <rect
          width="18"
          height="14"
          fill="white"
          transform="translate(-0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>,
  "Twitter"
);

export const Whatsapp = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 258"
  >
    <defs>
      <linearGradient
        id="logosWhatsappIcon0"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stop-color="#1faf38" />
        <stop offset="100%" stop-color="#60d669" />
      </linearGradient>
      <linearGradient
        id="logosWhatsappIcon1"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stop-color="#f9f9f9" />
        <stop offset="100%" stop-color="#fff" />
      </linearGradient>
    </defs>
    <path
      fill="url(#logosWhatsappIcon0)"
      d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a122.994 122.994 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"
    />
    <path
      fill="url(#logosWhatsappIcon1)"
      d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"
    />
    <path
      fill="#fff"
      d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561c0 15.67 11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716c-3.186-1.593-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"
    />
  </svg>,
  "Whatsapp"
);
